import { render } from "./Success.vue?vue&type=template&id=07648c2b&ts=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/ch-ocean-widget/ch-ocean-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__